import api from '../../services/api';

export const exportProducts = async (products) => {
    try {
        const response = await api.post(`/export-products`, 
            { products },
            { responseType: 'blob' }
        );
        return response.data;
    } catch (err) {
        return null;
    }
};

export const exportImages = async (images) => {
    try {
        const response = await api.post(`https://inspira.farmrio.com.br/showroom/v2/export-images`, 
        //const response = await api.post(`http://localhost:5000/showroom/v2/export-images`, 
            { images }
        );
        return response.data;
    } catch (err) {
        return null;
    }
};

export const loadProducts = async ({ delivery_id }) => {
    try {
        const response = await api.get(`products/${delivery_id}`, {
            params: { orderBy: 'delivery' },
        });
        return response.data;
    } catch (err) {
        return null;
    }
};